export default __webpack_public_path__ + "static/media/thumbnail3.531fb181.jpg";